import React from 'react';

function Header() {
    return (
        <header className="topnavbar-wrapper">
            {/* START Top Navbar */}
            <nav className="navbar topnavbar">
                {/* START navbar header */}
                <div className="navbar-header">
                    <a
                        className="navbar-brand"
                        href="#/"
                    >
                        <div className="brand-logo text-white">Halfwish</div>
                    </a>
                </div>
                {/* END navbar header */}
            </nav>
            {/* END Top Navbar */}
        </header>
    );
}

export default Header;
